export default "__VITE_ASSET__e528de12__"